import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Components } from '@app/modules/table/components';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { ColumnFilterPopupComponent } from './components/column-filter/column-filter-popup.component';
import { MultiFilterComponent } from './components/table-filters/multi-filter/multi-filter.component';

@NgModule({
    imports: [
        CommonModule,
        AppCommonModule,
        RouterModule,
        FormsModule,
        PlatformModule,
        ColumnFilterPopupComponent,
        MultiFilterComponent,
    ],
    declarations: [...Components],
    providers: [],
    exports: [...Components],
})
export class TableModule {}
